(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAirComponentDetails',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmFSAlerts(response) {
		Adzuki.CustomConfirm({
			body   : response.data,
			confirm: function yes() {
				$('#reservationaircomponentdetails-flightstats_alert_confirm').val(1);
				$('form[name="' + form.name + '"]').submit();
			}
		});
	};

	form.load = function load()
	{
		var form_name           = 'form_component_data[ReservationAirComponentDetails]';
		var label_name          = 'reservationaircomponentdetails';
		var departure_container = $('.departure-container');
		var return_container    = $('.return-container');
		var flight_type         = 'roundtrip';
		var form_action         = departure_container.data('action');
		var copy_details_label  = 'Copy airline and airport information from ';
		var return_airline_id   = '';
		var from_connection = '';
		var to_connection = '';

		// change flight_type when we load the form
		// and remove the return part of the form from the DOM
		// but save a referece if we need to add it later
		if ($('#' + label_name + '-flight_type-1').is(':checked')) {
			flight_type = 'oneway';
			return_container.detach().removeClass('hidden');
		}

		// when changing the flight type radio input
		// removes/inserts the "Return" portion of the flights
		$('input[type="radio"][name="' + form_name + '[flight_type]"]').change(function onFlightTypeChange()
		{
			flight_type = $(this).val();

			if (flight_type === 'oneway') {
				return_container = $('.return-container');
				return_container.detach();
			}

			if (flight_type === 'roundtrip') {
				departure_container.after(return_container);
				showReturnFlightCheckbox();
				addReturnFlightCheckboxEvent();
				addConnectingFlightEvent();

				return_container.find('.connection[data-index="0"] .field-airline select')
				.first()
				.change(function onAirlineChange(event)
				{
					var value = $(this).val();
					$(this).next().val(value);
				});

				if (form_action === 'add') {
					return_container.find('.connection[data-index="0"] .flight-lookup')
						.removeClass('hidden');

					return_container.find('.connection[data-index="0"] .manual-entry')
						.addClass('hidden');
				} else {
					return_airline_id = $('#' + label_name + '-return-0-airline').val();

					if (return_airline_id === '') {
						// return airline not set, so show flight lookup fields
						from_connection = departure_container.find('.connection').last();
						to_connection   = return_container.find('.connection').first();

						// copy last departure flight airline to return flight lookup airline
						return_airline_id = from_connection.find('select').val();
						to_connection.find('.field-airline select').val(return_airline_id);
						to_connection.find('.field-airline input[type="hidden"]').val(return_airline_id);

						return_container.find('.connection[data-index="0"] .flight-lookup')
							.removeClass('hidden');

						return_container.find('.connection[data-index="0"] .manual-entry')
							.addClass('hidden');
					} else {
						// return airline set, so show flight detail fields
						return_container.find('.connection[data-index="0"] .flight-lookup')
							.addClass('hidden');

						return_container.find('.connection[data-index="0"] .manual-entry')
							.removeClass('hidden');
					}
				}

				return_container.find('.connection[data-index="0"] .toggle-manual-entry')
					.off('click');
				return_container.find('.connection[data-index="0"] .toggle-manual-entry')
					.click(function onManualEntryClick(event)
					{
						event.preventDefault();
						$(this).closest('.flight-info').find('.manual-entry').removeClass('hidden');
						$(this).closest('.flight-info').find('.flight-lookup').addClass('hidden');
					});

				return_container.find('.connection[data-index="0"] .toggle-flight-lookup')
					.off('click');
				return_container.find('.connection[data-index="0"] .toggle-flight-lookup')
					.click(function onFlightLookupClick(event)
					{
						event.preventDefault();
						$(this).closest('.flight-info').find('.manual-entry').addClass('hidden');
						$(this).closest('.flight-info').find('.flight-lookup').removeClass('hidden');
					});

				return_container.find('.connection[data-index="0"] .get-flights')
					.off('click');
				return_container.find('.connection[data-index="0"] .get-flights')
					.click(function onGetFlightsClick(event)
					{
						event.preventDefault();
						getFlights($(this), event);
					});

			}
		});

		// clicking on copy airline info checkbox
		// on the return flight 1
		addReturnFlightCheckboxEvent();

		// when departure datepicker changes,
		// update the corresponding arrival datepicker
		// If the flight is roundtrip then update the return datepickers as well
		$('#' + label_name + '-departure-0-departure_datetime-date').on('dp.change', function onDepartureDpChange(event)
		{
			if (event.date) {
				$('#' + label_name + '-departure-0-arrival_datetime-date')
					.data('DateTimePicker')
					.date(event.date);

				if (flight_type === 'roundtrip') {
					$('#' + label_name + '-return-0-departure_datetime-date')
						.data('DateTimePicker')
						.date(event.date);

					$('#' + label_name + '-return-0-arrival_datetime-date')
						.data('DateTimePicker')
						.date(event.date);
				}
			}
		});

		// if roundtrip, then the return datepicker should also change on its own
		$('#' + label_name + '-return-0-departure_datetime-date').on('dp.change', function onReturnDpChange(event)
		{
			if (event.date) {
				$('#' + label_name + '-return-0-arrival_datetime-date')
					.data('DateTimePicker')
					.date(event.date);
			}
		});

		// When editing a flight, allow to remove the current selected airport
		// and choose a new one
		$('.toggle-airport-name').on('click', function showTypeaheadForm(event)
		{
			event.preventDefault();
			showAirportTypeahead($(this));
		});

		// When editing a flight, add events when the button
		// to remove a connection is clicked
		$('.close-flight').click(function onCloseFlightClick(event)
		{
			event.preventDefault();
			closeConnectingFlight($(this), event);
		});

		// when the airline drop-down changes,
		// update it's corresponding hidden field
		$('.field-airline select').change(function onAirlineChange(event)
		{
			var value = $(this).val();
			$(this).next().val(value);
		});

		// when operating airline drop-down changes, update corresponding hidden field
		$('.field-operating-airline select').change(function onAirlineChange(event)
		{
			var value = $(this).val();
			$(this).next().val(value);
		});

		$('.toggle-manual-entry').click(function onManualEntryClick(event)
		{
			event.preventDefault();
			$(this).closest('.flight-info').find('.manual-entry:not(.field-copy-details-departure)').removeClass('hidden');
			$(this).closest('.flight-info').find('.flight-lookup').addClass('hidden');
		});

		$('.toggle-flight-lookup').click(function onFlightLookupClick(event)
		{
			event.preventDefault();
			$(this).closest('.flight-info').find('.manual-entry').addClass('hidden');
			$(this).closest('.flight-info').find('.flight-lookup').removeClass('hidden');
		});

		$('.get-flights').click(function onGetFlightsClick(event)
		{
			event.preventDefault();
			getFlights($(this), event);
		});

		$('#' + label_name + '-set_final_payment_date').on('change', function change(e) {
			if ($(this).prop('checked') === true) {
				$('.final-payment-date').removeClass('hidden');
				$('.soft-payment-date').removeClass('hidden');
			} else {
				$('.final-payment-date').addClass('hidden');
				$('.soft-payment-date').addClass('hidden');
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#' + label_name + '-final_payment_date').on('dp.change', function dateChange(event) {
			var $final_payment_date     = $(this),
				$soft_payment_date      = $('#' + label_name + '-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if ($final_payment_date.val() === $final_payment_date.data('current-value')) {
				return;
			}

			$final_payment_date.data('current-value', $final_payment_date.val());

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						return true;
					}
				});
			}
		});

		addConnectingFlightEvent();

		/**
		 * When clicking the "Add connecting flight" button.
		 *
		 * @return {void}
		 */
		function addConnectingFlightEvent()
		{
			$('.connecting-flight').off().click(function onConnectingFlightClick(event)
			{
				var connection_type            = $(this).data('type');
				var connection_markup          = $('.connection').first().clone();
				var connection_parent          = null;
				var connection_parent_index    = null;
				var connection_parent_id_field = '';
				var close_btn                  = null;
				var leg_index                  = null;
				var leg_text                   = '';
				var leg_type_text              = '';
				var name_field                 = '';
				var id_field                   = '';
				var airline_value              = '';
				var operating_airline_value    = '';

				event.preventDefault();

				// find out where to insert this connection (departure or return)
				if (connection_type === 'departure') {
					connection_parent = departure_container.find('.connection').parent();
					leg_type_text     = 'Departure';
				} else {
					connection_parent = return_container.find('.connection').parent();
					leg_type_text     = 'Return';
				}

				// figure out the flight number
				leg_index = $('.connection[data-type="' + connection_type + '"]').length;
				leg_text  = 'FLIGHT ' + (leg_index + 1) + ':';

				// to get parent data as needed
				connection_parent_index = (leg_index - 1);

				// set data attributes for the created connecting flight
				connection_markup.attr('data-index', leg_index);
				connection_markup.attr('data-type', connection_type);
				connection_markup.find('.flight-number').html(leg_text);

				// show close button
				connection_markup.find('.close-flight')
								 .parent().parent().removeClass('hidden');

				// update index for the id and name on the form fields
				id_field   = label_name + '-' + connection_type + '-' + leg_index;
				name_field = form_name + '[' + connection_type + '][' + leg_index + ']';

				// for parent flight data
				connection_parent_id_field = label_name + '-' + connection_type + '-' + connection_parent_index;

				// When editing a flight, if an airport has been pre-selected,
				// just reset the selected airport. So they can type a new one or use
				// the "Copy details from" checkbox.
				if (connection_markup.find('.toggle-airport-name').length > 0) {
					connection_markup.find('.toggle-airport-name').each(function onEachAirportName(i, elem)
					{
						showAirportTypeahead($(elem));
					});
				}

				// show the copy details checkbox and update the text
				// of which flight details are we copying
				connection_markup.find('.copy-details').parent()
								 .parent().removeClass('hidden');
				connection_markup.find('.copy-details').parent()
								 .next()
								 .html(copy_details_label + 'Flight ' + leg_index);
				connection_markup.find('.copy-details')
								 .attr('id', id_field + '-copy_details');
				connection_markup.find('.copy-details')
								 .parent().next()
								 .attr('for', id_field + '-copy_details');
				connection_markup.find('.copy-details')
								 .attr('data-index', leg_index);
				connection_markup.find('.copy-details')
								 .attr('data-type', connection_type);
				connection_markup.find('.copy-details').first()
								 .on('click', function onCopyDetailsCheckboxClick(event)
				{
					copyFlightDetails($(this));
				});

				// update form fields: label "for", "id" and input "name"
				// this way they'll be sumbitted under their own index
				// airline
				connection_markup.find('.field-airline label')
								 .attr('for', id_field + '-airline');
				connection_markup.find('.field-airline select')
								 .attr('id', id_field + '-airline');
				connection_markup.find('.field-airline select')
								 .attr('name', name_field + '[airline]');
				connection_markup.find('.field-airline select')
								 .prop('disabled', false);
				connection_markup.find('.field-airline input[type="hidden"]')
								 .attr('name', name_field + '[airline]')
								 .val('');

				// operating airline
				connection_markup.find('.field-operating-airline label')
								 .attr('for', id_field + '-operating-airline');
				connection_markup.find('.field-operating-airline select')
								 .attr('id', id_field + '-operating-airline');
				connection_markup.find('.field-operating-airline select')
								 .attr('name', name_field + '[operating_airline]');
				connection_markup.find('.field-operating-airline select')
								 .prop('disabled', false);
				connection_markup.find('.field-operating-airline input[type="hidden"]')
								 .attr('name', name_field + '[operating_airline]')
								 .val('');

				// flight number
				connection_markup.find('.field-flight-number label')
								 .attr('for', id_field + '-flight_number');
				connection_markup.find('.field-flight-number input')
								 .attr('id', id_field + '-flight_number');
				connection_markup.find('.field-flight-number input')
								 .attr('name', name_field + '[flight_number]');
				connection_markup.find('.field-flight-number input')
								 .val('');

				// airline lookup
				connection_markup.find('.field-airline.flight-lookup label')
								 .attr('for', id_field + '-airline_lookup');
				connection_markup.find('.field-airline.flight-lookup select')
								 .attr('id', id_field + '-airline_lookup');
				connection_markup.find('.field-airline.flight-lookup select')
								 .attr('name', name_field + '[airline_lookup]');
				connection_markup.find('.field-airline.flight-lookup select')
								 .prop('disabled', false);
				connection_markup.find('.field-airline.flight-lookup input[type="hidden"]')
								 .attr('name', name_field + '[airline_lookup]');

				// flight number lookup
				connection_markup.find('.field-flight-number.flight-lookup label')
								 .attr('for', id_field + '-flight_number_lookup');
				connection_markup.find('.field-flight-number.flight-lookup input')
								 .attr('id', id_field + '-flight_number_lookup');
				connection_markup.find('.field-flight-number.flight-lookup input')
								 .attr('name', name_field + '[flight_number_lookup]');
				connection_markup.find('.field-flight-number.flight-lookup input')
								 .val('');

				// pnr
				connection_markup.find('.field-pnr label')
								 .attr('for', id_field + '-pnr');
				connection_markup.find('.field-pnr input')
								 .attr('id', id_field + '-pnr');
				connection_markup.find('.field-pnr input')
								 .attr('name', name_field + '[pnr]');
				connection_markup.find('.field-pnr input')
								 .val('');

				// seats
				connection_markup.find('.field-seats label')
								 .attr('for', id_field + '-seats');
				connection_markup.find('.field-seats input')
								 .attr('id', id_field + '-seats');
				connection_markup.find('.field-seats input')
								 .attr('name', name_field + '[seats]');
				connection_markup.find('.field-seats input')
								 .val('');

				// seat types
				connection_markup.find('.field-seat-type label')
								 .attr('for', id_field + '-seat-type');
				connection_markup.find('.field-seat-type input')
								 .attr('id', id_field + '-seat-type');
				connection_markup.find('.field-seat-type input')
								 .attr('name', name_field + '[seat_type]');
				connection_markup.find('.field-seat-type input')
								 .val('');

				// departure airport
				connection_markup.find('.field-departure-airport label')
								 .attr('for', id_field + '-departure_airport');
				connection_markup.find('.field-departure-airport input[type="text"]')
								 .attr('data-hidden-id', id_field + '-departure_airport');
				connection_markup.find('.field-departure-airport input[type="text"]')
								 .attr('id', id_field + '-airport_search');
				connection_markup.find('.field-departure-airport input[type="text"]')
								 .attr('name', name_field + '[airport_search]');
				connection_markup.find('.field-departure-airport input[type="hidden"]')
								 .attr('id', id_field + '-departure_airport');
				connection_markup.find('.field-departure-airport input[type="hidden"]')
								 .attr('name', name_field + '[departure_airport]');

				// departure terminal
				connection_markup.find('.field-departure-terminal label')
								 .attr('for', id_field + '-departure_terminal');
				connection_markup.find('.field-departure-terminal input')
								 .attr('name', name_field + '[departure_terminal]');
				connection_markup.find('.field-departure-terminal input')
								 .attr('id', id_field + '-departure_terminal');
				connection_markup.find('.field-departure-terminal input')
								 .val('');

				// flight lookup departure date
				connection_markup.find('.field-departure-date label')
								 .attr('for', id_field + '-departure_date');
				connection_markup.find('.field-departure-date input[type!="hidden"]')
								 .first()
								 .attr('id', id_field + '-departure_date-date')
								 .attr('name', name_field + '[departure_date][date]')
								 .attr('type', 'date')
								 .data('value', '');
				connection_markup.find('.field-departure-date input[type="hidden"]')
								 .remove();

				// departure date/time
				// The hidden fields are being removed cause they'll be re-added
				// by the Adzuki.DateTimePicker()
				connection_markup.find('.field-departure-datetime label')
								 .attr('for', id_field + '-departure_datetime');
				connection_markup.find('.field-departure-datetime input[type="text"], .field-departure-datetime input[type="date"]')
								 .first()
								 .attr('id', id_field + '-departure_datetime-date')
								 .attr('name', name_field + '[departure_datetime][date]')
								 .attr('type', 'date')
								 .data('value', '')
								 .val('');
				connection_markup.find('.field-departure-datetime input[type="text"], .field-departure-datetime input[type="time"]')
								 .first()
								 .attr('id', id_field + '-departure_datetime-time')
								 .attr('name', name_field + '[departure_datetime][time]')
								 .attr('type', 'time')
								 .data('value', '')
								 .val('');
				connection_markup.find('.field-departure-datetime input[type="hidden"]')
								 .remove();

				// arrival airport
				connection_markup.find('.field-arrival-airport label')
								 .attr('for', id_field + '-arrival_airport');
				connection_markup.find('.field-arrival-airport input[type="text"]')
								 .attr('name', name_field + '[airport_search]');
				connection_markup.find('.field-arrival-airport input[type="text"]')
								 .attr('data-hidden-id', id_field + '-arrival_airport');
				connection_markup.find('.field-arrival-airport input[type="text"]')
								 .attr('id', id_field + '-airport_search');
				connection_markup.find('.field-arrival-airport input[type="hidden"]')
								 .attr('id', id_field + '-arrival_airport');
				connection_markup.find('.field-arrival-airport input[type="hidden"]')
								 .attr('name', name_field + '[arrival_airport]');

				// arrival terminal
				connection_markup.find('.field-arrival-terminal label')
								 .attr('for', id_field + '-arrival_terminal');
				connection_markup.find('.field-arrival-terminal input')
								 .attr('id', id_field + '-arrival_terminal');
				connection_markup.find('.field-arrival-terminal input')
								 .attr('name', name_field + '[arrival_terminal]');
				connection_markup.find('.field-arrival-terminal input')
								 .val('');

				// arrival date/time
				// The hidden fields are being removed cause they'll be re-added
				// by the Adzuki.DateTimePicker()
				connection_markup.find('.field-arrival-datetime label')
								 .attr('for', id_field + '-arrival_datetime');
				connection_markup.find('.field-arrival-datetime input[type="text"], .field-arrival-datetime input[type="date"]')
								 .first()
								 .attr('id', id_field + '-arrival_datetime-date')
								 .attr('name', name_field + '[arrival_datetime][date]')
								 .attr('type', 'date')
								 .data('value', '')
								 .val('');
				connection_markup.find('.field-arrival-datetime input[type="text"], .field-arrival-datetime input[type="time"]')
								 .first()
								 .attr('id', id_field + '-arrival_datetime-time')
								 .attr('name', name_field + '[arrival_datetime][time]')
								 .attr('type', 'time')
								 .data('value', '')
								 .val('');
				connection_markup.find('.field-arrival-datetime input[type="hidden"]')
								 .remove();

				// insert the connecting flight
				connection_parent.append('<hr>');
				connection_parent.append(connection_markup);

				// re-initialize typeaheads
				$.each(connection_markup.find('input.airport-typeahead'), function reInitTypeaheads(i, el)
				{
					Adzuki.Typeahead(
						$(el),
						'/Airports/search',
						function _selected_airport(airport, $self, typeahead)
						{
							if (airport.id) {
								typeahead.setHiddenValue(airport.id);
							} else {
								$self.val('');
							}
						}
					);
				});

				// reset typeaheads
				connection_markup.find('.field-departure-airport input.airport-typeahead')
								 .first().data('adzuki').reset();
				connection_markup.find('.field-arrival-airport input.airport-typeahead')
								 .first().data('adzuki').reset();

				// re-initialize datepickers
				$.each(connection_markup.find('input[type="date"]'), function reInitDatePicker(i, el)
				{
					Adzuki.DateTimePicker($(el));
					$(el).data('DateTimePicker')
						.date('');
					$(el).siblings(Adzuki.FaIcon.getIconSelector('close')).addClass('hidden');
				});

				// re-initialize timepickers
				$.each(connection_markup.find('input[type="time"]'), function reInitTimePicker(i, el)
				{
					Adzuki.DateTimePicker($(el), 'hh:mm a', 'HH:mm:ss');
					$(el).data('DateTimePicker')
						.date('');
					$(el).siblings(Adzuki.FaIcon.getIconSelector('close')).addClass('hidden');
				});

				// set new field dates based on the parent arrival date
				if ($('#' + connection_parent_id_field + '-arrival_datetime-date').val() !== '') {
					// flight lookup departure date
					$('#' + id_field + '-departure_date-date')
						.data('DateTimePicker')
						.date($('#' + connection_parent_id_field + '-arrival_datetime-date').val());

					// manual entry departure/arrival dates
					$('#' + id_field + '-departure_datetime-date')
						.data('DateTimePicker')
						.date($('#' + connection_parent_id_field + '-arrival_datetime-date').val());

					$('#' + id_field + '-arrival_datetime-date')
						.data('DateTimePicker')
						.date($('#' + connection_parent_id_field + '-arrival_datetime-date').val());
				}

				// when flight lookup departure datepicker changes,
				// update the corresponding departure/arrival datepickers
				$('#' + id_field + '-departure_date-date').on('dp.change', function onDepartureDpChange(event)
				{
					if (event.date) {
						// manual departure entry
						$('#' + id_field + '-departure_datetime-date')
							.data('DateTimePicker')
							.date(event.date);

						// manual arrival entry
						$('#' + id_field + '-arrival_datetime-date')
							.data('DateTimePicker')
							.date(event.date);
					}
				});

				// when manual entry departure datepicker changes,
				// update the corresponding arrival datepicker and hidden flight lookup departure date
				$('#' + id_field + '-departure_datetime-date').on('dp.change', function onDepartureDpChange(event)
				{
					if (event.date) {
						// flight lookup departure
						$('#' + id_field + '-departure_date-date')
							.data('DateTimePicker')
							.date(event.date);

						// manual arrival entry
						$('#' + id_field + '-arrival_datetime-date')
							.data('DateTimePicker')
							.date(event.date);
					}
				});

				// show flight lookup fields by default
				connection_markup.find('.flight-lookup').removeClass('has-error');
				connection_markup.find('.flight-lookup').removeClass('hidden');
				connection_markup.find('.flight-search-results').addClass('hidden');
				connection_markup.find('tr.flight:not(.template)')
					.remove();

				// when the airline drop-down changes,
				// update it's corresponding hidden field
				connection_markup.find('.field-airline select').change(function onAirlineChange(event)
				{
					var value = $(this).val();
					$(this).next().val(value);
				});

				// when the operating airline drop-down changes, update hidden field
				connection_markup.find('.field-operating-airline select').change(function onOperatingAirlineChange(event)
				{
					var value = $(this).val();
					$(this).next().val(value);
				});

				airline_value = $('select[name="' + form_name + '[' + connection_type + '][0][airline]"]').val();
				connection_markup.find('select[name="' + name_field + '[airline_lookup]"] option').attr('selected', false);
				connection_markup.find('select[name="' + name_field + '[airline_lookup]"] option[value="' + airline_value + '"]').attr('selected', true);
				connection_markup.find('select[name="' + name_field + '[airline_lookup]"]').next().val(airline_value);
				connection_markup.find('select[name="' + name_field + '[airline]"] option[value="' + airline_value + '"]').attr('selected', true);
				connection_markup.find('select[name="' + name_field + '[airline]"]').next().val(airline_value);

				operating_airline_value = $('select[name="' + form_name + '[' + connection_type + '][0][operating_airline]"]').val();
				connection_markup.find('select[name="' + name_field + '[operating_airline]"] option[value="' + operating_airline_value + '"]').attr('selected', true);
				connection_markup.find('select[name="' + name_field + '[operating_airline]"]').next().val(operating_airline_value);

				// hide manual entry by default
				connection_markup.find('.manual-entry').addClass('hidden');

				connection_markup.find('.toggle-manual-entry').click(function onManualEntryClick(event)
				{
					event.preventDefault();
					$(this).closest('.flight-info').find('.manual-entry').removeClass('hidden');
					$(this).closest('.flight-info').find('.flight-lookup').addClass('hidden');
				});

				connection_markup.find('.toggle-flight-lookup').click(function onFlightLookupClick(event)
				{
					event.preventDefault();
					$(this).closest('.flight-info').find('.manual-entry').addClass('hidden');
					$(this).closest('.flight-info').find('.flight-lookup').removeClass('hidden');
				});

				connection_markup.find('.get-flights').click(function onGetFlightsClick(event)
				{
					event.preventDefault();
					getFlights($(this), event);
				});

				// give focus to the airline dropdown to avoid browser scrolling issues
				// commenting this out for now because still scrolling issue when agent adds connection, at least this won't move the screen
				// connection_markup.find('.field-airline select')
				// 				 .focus();

				// success message
				Adzuki.StatusMessage('success', leg_type_text + ' Flight ' + (leg_index + 1) + ' has been added, please enter the details.');

				// clicking the close button on the connection
				close_btn = connection_markup.find('.close-flight');
				close_btn.attr('data-index', leg_index);
				close_btn.attr('data-type', connection_type);
				close_btn.click(function onCloseFlightClick(event)
				{
					event.preventDefault();
					closeConnectingFlight($(this), event);
				});
			});
		}

		/**
		 * Remove a connecting flight, this method is called
		 * when a click to the close button is triggered
		 *
		 * @param  {jQuery} close_btn
		 * @param  {Object} event
		 *
		 * @return {void}
		 */
		function closeConnectingFlight(close_btn, event)
		{
			var btn_index     = close_btn.attr('data-index');
			var btn_conn_type = close_btn.attr('data-type');

			// remove the flight connection, but ask first
			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove this connecting flight?',
				confirm: function removeConnectingFlight() {
					var conn_to_remove = $('.connection[data-index="' + btn_index + '"][data-type="' + btn_conn_type + '"]');
					conn_to_remove.prev().remove(); // removing the <hr>
					conn_to_remove.remove();
					updateConnectionLegs(btn_conn_type);
					// Keep the success message from popping up too quickly.
					setTimeout(function _statusMessageTimeout()
					{
						Adzuki.StatusMessage('success', 'Connecting flight has been removed.');
					}, 1000);
				}
			});
		}

		/**
		 * Copy the airline, terminal and airport details
		 * from the previous connection to the current clicked connection.
		 *
		 * @param  {jQuery} $checkbox
		 *
		 * @return {void}
		 */
		function copyFlightDetails($checkbox)
		{
			var pnr                    = null;
			var airline                = null;
			var operating_airline      = null;
			var departure_terminal     = null;
			var arrival_terminal       = null;
			var type                   = $checkbox.attr('data-type');
			var index                  = parseInt($checkbox.attr('data-index'));
			var from_conn              = null;
			var to_conn                = null;
			var from_conn_selector     = '';
			var to_conn_selector       = '';
			var arrival_airport        = '';
			var arrival_airport_text   = '';
			var departure_airport      = null;
			var departure_airport_text = null;
			var arrival_date           = null;

			if ($checkbox.is(':checked')) {
				// I'm copying the details from the first departure flight
				// into the first return flight, do nothing else after this
				if (type === 'return' && index === 0) {
					from_conn = departure_container.find('.connection').last();
					to_conn   = return_container.find('.connection').first();

					// copy airline
					airline = from_conn.find('.field-airline select').val();
					to_conn.find('.field-airline select').val(airline);
					to_conn.find('.field-airline input[type="hidden"]').val(airline);

					// copy operating airline
					operating_airline = from_conn.find('.field-operating-airline select').val();
					to_conn.find('.field-operating-airline select').val(operating_airline);
					to_conn.find('.field-operating-airline input[type="hidden"]').val(operating_airline);

					// copy pnr
					pnr = from_conn.find('.field-pnr input').val();
					to_conn.find('.field-pnr input').val(pnr);

					// copy terminal
					departure_terminal = from_conn
						.find('.field-departure-terminal input[type="text"]')
						.val();
					arrival_terminal = from_conn
						.find('.field-arrival-terminal input[type="text"]')
						.val();
					to_conn
						.find('.field-arrival-terminal input[type="text"]')
						.val(departure_terminal);
					to_conn
						.find('.field-departure-terminal input[type="text"]')
						.val(arrival_terminal);

					// copy airport
					arrival_airport = from_conn
						.find('.field-arrival-airport')
						.first().find('input[type="hidden"]').val();
					departure_airport = from_conn
						.find('.field-departure-airport')
						.first().find('input[type="hidden"]').val();

					if (arrival_airport) {
						arrival_airport_text = from_conn
							.find('.field-arrival-airport')
							.first().find('input[type="text"]').val();

						// attempting to copy from an airport that it's already
						// selected (aka. on an edit page)
						if (!arrival_airport_text) {
							arrival_airport_text = from_conn
								.find('.field-arrival-airport')
								.first().find('.pre-selected-airport-typeahead')
								.text();
						}

						to_conn
							.find('.field-departure-airport')
							.first().find('input[type="text"]')
							.val(arrival_airport_text.trim());
						to_conn
							.find('.field-departure-airport')
							.first().find('input.airport-typeahead')
							.data('adzuki').setHiddenValue(arrival_airport);
					}

					if (departure_airport) {
						departure_airport_text = from_conn
							.find('.field-departure-airport')
							.first().find('input[type="text"]').val();

						// attempting to copy from an airport that it's already
						// selected (aka. on an edit page)
						if (!departure_airport_text) {
							departure_airport_text = from_conn
								.find('.field-departure-airport')
								.first().find('.pre-selected-airport-typeahead')
								.text();
						}

						to_conn
							.find('.field-arrival-airport')
							.first().find('input[type="text"]')
							.val(departure_airport_text.trim());
						to_conn
							.find('.field-arrival-airport')
							.first().find('input.airport-typeahead')
							.data('adzuki').setHiddenValue(departure_airport);
					}

					return;
				}

				// copying details from Flight x to Flight y in the same leg
				from_conn_selector = '.connection[data-index="' + (index - 1) + '"][data-type="' + type + '"]';
				to_conn_selector   = '.connection[data-index="' + index + '"][data-type="' + type + '"]';

				// if we are copying the details from flight 1
				// find the correct flight container to copy details from
				if ($(document).find(from_conn_selector).length === 0) {
					if (type === 'departure') {
						from_conn = departure_container.find('.connection').first();
					} else {
						from_conn = return_container.find('.connection').first();
					}
				} else {
					from_conn = $(document)
						.find(from_conn_selector)
						.first();
				}

				// Just copying "Arriving To" data from Flight x
				// into the "Departing From" data from Flight (x + 1)
				to_conn = $(document)
					.find(to_conn_selector)
					.first();

				// copy airline
				airline = from_conn.find('.field-airline select').val();
				to_conn.find('.field-airline select').val(airline);
				to_conn.find('.field-airline input[type="hidden"]').val(airline);

				operating_airline = from_conn.find('.field-operating-airline select').val();
				to_conn.find('.field-operating-airline select').val(operating_airline);
				to_conn.find('.field-operating-airline input[type="hidden"]').val(operating_airline);

				// copy pnr
				pnr = from_conn.find('.field-pnr input').val();
				to_conn.find('.field-pnr input').val(pnr);

				// copy terminal
				arrival_terminal = from_conn
					.find('.field-arrival-terminal input[type="text"]')
					.val();
				to_conn
					.find('.field-departure-terminal input[type="text"]')
					.val(arrival_terminal);

				// copy airport
				arrival_airport = from_conn
					.find('.field-arrival-airport')
					.first().find('input[type="hidden"]').val();

				if (arrival_airport) {
					arrival_airport_text = from_conn
						.find('.field-arrival-airport')
						.first().find('input[type="text"]').val();

					// attempting to copy from an airport that it's already
					// selected (aka. on an edit page)
					if (!arrival_airport_text) {
						arrival_airport_text = from_conn
							.find('.field-arrival-airport')
							.first().find('.pre-selected-airport-typeahead')
							.text();
					}

					to_conn
						.find('.field-departure-airport')
						.first().find('input[type="text"]')
						.val(arrival_airport_text.trim());
					to_conn
						.find('.field-departure-airport')
						.first().find('input.airport-typeahead')
						.data('adzuki').setHiddenValue(arrival_airport);
				}

				// get the arrival date from the previous leg,
				// and set departure/arrival dates on this leg to that value :D
				arrival_date = from_conn
					.find('.field-arrival-datetime')
					.first().find('input[type="hidden"]').first().val();

				to_conn
					.find('.field-departure-datetime').first()
					.find('input[type="text"]').first()
					.data('DateTimePicker').date(arrival_date);

				to_conn
					.find('.field-arrival-datetime').first()
					.find('input[type="text"]').first()
					.data('DateTimePicker').date(arrival_date);
			}
		}

		/**
		 * Update the flight number on all of the existing connections
		 * for the specified type (departure or return)
		 *
		 * @param  {string} connection_type
		 *
		 * @return {void}
		 */
		function updateConnectionLegs(connection_type)
		{
			// update the flight number on all of the connection elements
			$('.connection[data-type="' + connection_type + '"]').each(function onEachConnectionElement(i, elem) {
				var id_field = label_name + '-' + connection_type + '-' + i;

				// change flight number
				$(elem).find('.flight-number')
					   .html('FLIGHT ' + String(i + 1) + ':');

				// change data attributes on the .connection
				$(elem).attr('data-index', String(i));

				// change data attr on the close button
				$(elem).find('.close-flight')
					   .attr('data-index', String(i));

				// change data attr on the checkbox to copy the flight details
				// and re-attach events
				$(elem).find('.copy-details')
					   .attr('data-index', String(i));
				$(elem).find('.copy-details')
					   .attr('id', id_field + '-copy_details');
				$(elem).find('.copy-details')
					   .off().on('click', function onCopyDetailsCheckboxClick(event)
				{
					copyFlightDetails($(this));
				});

				// also update checkbox label
				if (i !== 0) {
					$(elem).find('.copy-details-label')
						   .html(copy_details_label + 'Flight ' + String(i));
				}

				$(elem).find('.copy-details-label')
					   .attr('for', id_field + '-copy_details');

				// update labels and ids
				// arrival airport
				$(elem).find('.field-arrival-airport label')
					   .attr('for', id_field + '-arrival_airport');
				$(elem).find('.field-arrival-airport input[type="text"]')
					   .attr('data-hidden-id', id_field + '-arrival_airport');
				$(elem).find('.field-arrival-airport input[type="text"]')
					   .attr('id', id_field + '-airport_search');
				$(elem).find('.field-arrival-airport input[type="hidden"]')
					   .attr('id', id_field + '-arrival_airport');
			});
		}

		/**
		 * When we are adding a flight connection, if an airport is already selected
		 * just reset it so a new one can be chosen.
		 *
		 * @param  {jQuery} edit_btn
		 *
		 * @return {void}
		 */
		function showAirportTypeahead(edit_btn)
		{
			var parent            = edit_btn.parent();
			var airport_typeahead = parent.next('.airport-typeahead');

			parent.addClass('hidden');
			airport_typeahead.removeClass('hidden');

			// remove saved id
			airport_typeahead.find('input[type="hidden"]')
							 .first().val('');
		}

		/**
		 * When clicking on copy airline info checkbox
		 * on the return flight 1
		 *
		 * @return {void}
		 */
		function addReturnFlightCheckboxEvent()
		{
			var selector = '#' + label_name + '-return-0-copy_details';

			$(selector).off().on('click', function onCopyDetailsCheckboxClick(event)
			{
				copyFlightDetails($(this));
			});
		}

		/**
		 * It shows the copy details checkbox on the return flight 1
		 *
		 * @return {void}
		 */
		function showReturnFlightCheckbox()
		{
			var selector = '#' + label_name + '-return-0-copy_details';

			$(selector).parent().parent().removeClass('hidden');
		}

		/**
		 * When the Find Flight button is clicked, show the list of flights
		 * generated from the AJAX response.
		 *
		 * @param {jQuery} $self
		 * @param {object} event
		 *
		 * @return {void}
		 */
		function getFlights($self, event)
		{
			var $flight_container        = $self.closest('.flight-info'),
				$flight_connection       = $flight_container.closest('.connection'),
				$flight_lookup_container = $flight_container.find('.flight-search-results'),
				$flight_lookup_fields    = $flight_container.find('.flight-lookup'),
				$flight_list             = $flight_lookup_container.find('table'),
				$flight_template         = $flight_lookup_container.find('tr.flight.template'),
				flight_data              = $flight_lookup_fields.find('input').serializeArray(),
				flights                  = [];

			$self.prop('disabled', true);
			$flight_lookup_container.addClass('hidden');
			$flight_lookup_fields.removeClass('has-error');
			$flight_template.siblings().remove();

			flight(flight_data, function flightLookupResponse(data)
			{
				data.flights.forEach(function _displayFlights(flight, i)
				{
					var $flight_row    = $flight_template.clone(),
						$select_button = $flight_row.find('.btn.select-flight'),
						departure_time = moment(flight.departure_time).format('h:mm a'),
						arrival_time   = moment(flight.arrival_time).format('h:mm a'),
						field_name;

					$flight_row.find('.departure')
						.html(flight.airports.departure.iata + ' (' + departure_time + ')');
					$flight_row.find('.arrival')
						.html(flight.airports.arrival.iata + ' (' + arrival_time + ')');
					$flight_row.removeClass('template hidden');

					$select_button.data('flight', flight);
					$select_button.click(function selectFlightClick(event)
					{
						event.preventDefault();
						selectFlight($(this), event);
						if (
							$flight_connection.data('type') === 'departure'
							&& $flight_connection.data('index') === 0
						) {
							field_name = '[name="form_component_data[ReservationAirComponentDetails][return][0][airline_lookup]"]';
							$('select' + field_name).find('option').attr('selected', false);
							$('select' + field_name).find('option[value="' + flight.airline.id + '"]').attr('selected', true);
							$('input' + field_name).val(flight.airline.id);
						}
					});
					flights.push($flight_row);
				});
				$flight_list.prepend(flights);

				$flight_lookup_container.removeClass('hidden');
				$self.prop('disabled', false);
			}, function getFlightLookupError(errors)
			{
				var message,
					error_list = [];

				$self.prop('disabled', false);
				if (typeof errors === 'string') {
					message = errors;
				} else {
					errors.forEach(function _showFieldErrors(err)
					{
						var form_group = $flight_lookup_fields.find('[name="' + err + '"]')
							.closest('.form-group')
							.addClass('has-error');
						error_list.push(form_group.data('proper') + ' must be provided');
					});
					message = 'The form could not be submitted for the following reason(s):<br><br>';
					message = message + '<ul><li>' + error_list.join('</li><li>') + '</li></ul>';
				}

				Adzuki.StatusMessage('error', message);
			});
		}

		/**
		 * Once select button is clicked from list of flights
		 * generated from flight lookup, populate fields.
		 *
		 * @param {jQuery} $self
		 * @param {object} event
		 *
		 * @return {void}
		 */
		function selectFlight($self, event)
		{
			var $flight_leg           = $self.closest('.flight-info'),
				$connection           = $flight_leg.closest('.connection'),
				flight                = $self.data('flight'),
				$available_flights    = $flight_leg.find('.flight-search-results'),
				$manual_entry         = $flight_leg.find('.manual-entry'),
				$manual_entry_toggle  = $flight_leg.find('.toggle-manual-entry'),
				input_data            = [],
				$preselect,
				field_key_array,
				field_key,
				// field_id,
				date_input,
				time_input,
				i;

			input_data = {
				vendor           : flight.airline.name,
				vendor_id        : $flight_leg.find('.flight-search-results .vendor-id').val(),
				airline          : flight.airline.id,
				flight_number    : flight.flight_number,
				departure_airport: {
					id  : flight.airports.departure.id,
					iata: flight.airports.departure.iata,
					name: flight.airports.departure.name
				},
				arrival_airport: {
					id  : flight.airports.arrival.id,
					iata: flight.airports.arrival.iata,
					name: flight.airports.arrival.name
				},
				departure_datetime: flight.departure_time,
				arrival_datetime  : flight.arrival_time,
				departure_terminal: flight.departure_terminal,
				arrival_terminal  : flight.arrival_terminal
			};

			field_key_array = [
				'ReservationAirComponentDetails',
				$connection.data('type'),
				$connection.data('index'),
			];

			for (i in input_data) {
				if ({}.hasOwnProperty.call(input_data, i)) {
					if (field_key_array.length > 0) {
						field_key_array[3] = i;
						field_key          = field_key_array.join('][');
						// field_id           = field_key_array.join('-');
						// field_id           = field_id.toLowerCase();
					}

					if (i.indexOf('datetime') > -1) {
						date_input = $manual_entry.find('input[name="form_component_data[' + field_key + '][date]"]');
						time_input = $manual_entry.find('input[name="form_component_data[' + field_key + '][time]"]');

						// inputs will be the DTP hidden inputs on desktop
						if (!Adzuki.is_mobile) {
							date_input = date_input.prev('input[type="text"]');
							time_input = time_input.prev('input[type="text"]');
						}

						if (date_input.val() !== undefined) {
							if (!moment(input_data[i]).isSame(moment(date_input.val(), 'MM/DD/YYYY'), 'day')) {
								date_input.data('DateTimePicker').date(moment(input_data[i]));
							}
						}

						if (!(typeof time_input.data('DateTimePicker') === 'undefined')) {
							time_input.data('DateTimePicker').date(moment(input_data[i]));
						}
					} else if (i.indexOf('_airport') > -1) {
						$manual_entry.find('input[name="form_component_data[' + field_key + ']"]')
							.siblings('.input-group')
							.find('input.airport-typeahead')
							.data('adzuki')
							.setHiddenValue(input_data[i].id);

						$preselect = $manual_entry.find('input[name="form_component_data[' + field_key + ']"]')
							.closest('.airport-typeahead')
							.siblings('.pre-selected-airport-typeahead');

						$manual_entry.find('input[name="form_component_data[' + field_key + ']"]')
							.closest('.airport-typeahead')
							.addClass('hidden');

						$preselect.removeClass('hidden');
						$preselect.find('.airport-name')
							.html(input_data[i].name);
					} else {
						if (i === 'airline') {
							$flight_leg.find('.field-airline.manual-entry')
								.find('select option[value="' + input_data[i] + '"]')
								.attr('selected', 1);
						}
						$manual_entry.find('input[name="form_component_data[' + field_key + ']"]')
							.val(input_data[i]);
					}
				}
			}

			$available_flights.addClass('hidden');
			$manual_entry_toggle.click();

			Adzuki.StatusMessage('success', 'Your flight has been selected.');
		}

		/**
		 * Get flight info from FlightStats.
		 *
		 * @param {object} data
		 * @param {function} success
		 * @param {function} error
		 *
		 * @return mixed
		 */
		function flight(data, success, error)
		{
			var errors = [],
				airline,
				flight_number,
				departure_date,
				params;

			data.forEach(function _prepareFlightLookupData(obj) {
				if ($.trim(obj.value) === '') {
					if (errors.indexOf(obj.name) === -1) {
						errors.push(obj.name);
					}
				}

				if (obj.name.match(/airline/)) {
					airline = obj.value;
				} else if (obj.name.match(/flight_number/)) {
					flight_number = obj.value;
				} else if (obj.name.match(/departure_date/)) {
					departure_date = obj.value;
				} else {
					errors.push(obj.name);
				}
			});

			if (errors.length) {
				return error(errors);
			}

			params = [airline, flight_number, departure_date];
			params = params.join('/');

			return $.ajax({
				url     : Adzuki.base_uri + '/flightStats/airSearch/' + params,
				method  : 'post',
				dataType: 'json',
				data    : data,
				success : function _successResponse(response)
				{
					if (undefined === response.flights) {
						error(response.error || 'Error');
					} else {
						success(response);
					}
				},
				error: function _errorResponse(err)
				{
					error('Error');
				}
			});
		}

	};

}(jQuery, window.Adzuki || {}));
